import { RootState } from "../store";
import { INotificationState } from "../types/state";

export const getNotification = (state: RootState): INotificationState["notification"] =>
  state.notification.notification;
